export const buildSentryDsn = (baseDomain?: string, projectId?: number, clientKey?: string) => {
  if (!baseDomain || !projectId || isNaN(Number(projectId)) || !clientKey) {
    return undefined;
  }

  return `https://${clientKey}@${baseDomain}/${projectId}`;
};
